var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNdllNuevo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 193.167,
    height: 18.774,
    viewBox: "0 0 193.167 18.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6804",
    "data-name": "Rectangle 6804",
    width: 193.167,
    height: 18.774,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9162",
    "data-name": "Group 9162",
    transform: "translate(0 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9161",
    "data-name": "Group 9161",
    transform: "translate(0 4)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25670",
    "data-name": "Path 25670",
    d: "M10.954,9.861q0-.641.665-.642H15.54q.665,0,.665.642v15.35q0,.641-.665.642H12.4a.912.912,0,0,1-.808-.38L5.228,17.987v7.224a.567.567,0,0,1-.642.642H.665Q0,25.852,0,25.211V9.861q0-.641.665-.642H3.778a1.109,1.109,0,0,1,.832.38l6.344,7.628Z",
    transform: "translate(0 -7.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25671",
    "data-name": "Path 25671",
    d: "M102.139,5.228a2.83,2.83,0,0,1-2.02-.737,2.462,2.462,0,0,1-.784-1.877,2.473,2.473,0,0,1,.784-1.865,3.084,3.084,0,0,1,4.028,0,2.456,2.456,0,0,1,.8,1.865,2.445,2.445,0,0,1-.8,1.877,2.841,2.841,0,0,1-2.008.737M100.285,18.32q-.666,0-.665-.642V7.176q0-.618.665-.618h3.707q.665,0,.665.618v10.5q0,.642-.665.642Z",
    transform: "translate(-81.157 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25672",
    "data-name": "Path 25672",
    d: "M153.353,21.062a.629.629,0,0,1-.523.737,9.982,9.982,0,0,1-2.281.262,3.913,3.913,0,0,1-3.541-1.521,4.862,4.862,0,0,1-3.968,1.521,5.952,5.952,0,0,1-4.467-1.758,6.3,6.3,0,0,1-1.711-4.586,6.257,6.257,0,0,1,1.711-4.574A5.974,5.974,0,0,1,143.04,9.4a5.09,5.09,0,0,1,3.208.974v-5.7q0-.641.665-.642h3.707a.567.567,0,0,1,.642.642V16.9a1.28,1.28,0,0,0,.166.76.679.679,0,0,0,.57.214,2.241,2.241,0,0,0,.356-.024q.641,0,.713.546Zm-9.433-2.685a2.116,2.116,0,0,0,1.687-.713,2.875,2.875,0,0,0,.618-1.948,2.886,2.886,0,0,0-.618-1.937,2.1,2.1,0,0,0-1.687-.725,2.033,2.033,0,0,0-1.639.737,2.894,2.894,0,0,0-.618,1.925,2.893,2.893,0,0,0,.618,1.925,2.032,2.032,0,0,0,1.639.737",
    transform: "translate(-111.817 -3.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25673",
    "data-name": "Path 25673",
    d: "M239.109,46.036a7.153,7.153,0,0,1-5.037-1.747,5.947,5.947,0,0,1-1.9-4.6,5.91,5.91,0,0,1,1.9-4.586,7.184,7.184,0,0,1,5.037-1.735,7.264,7.264,0,0,1,5.073,1.735,5.9,5.9,0,0,1,1.913,4.586,5.931,5.931,0,0,1-1.913,4.6,7.232,7.232,0,0,1-5.073,1.747m0-3.921a2.449,2.449,0,0,0,1.794-.665,2.622,2.622,0,0,0,0-3.517,2.451,2.451,0,0,0-1.794-.665,2.425,2.425,0,1,0,0,4.847",
    transform: "translate(-189.685 -27.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25674",
    "data-name": "Path 25674",
    d: "M319.645,46.036a8.757,8.757,0,0,1-4.372-.986,3.819,3.819,0,0,1-2.043-2.673.479.479,0,0,1,.1-.475.714.714,0,0,1,.523-.166h3.113a1.177,1.177,0,0,1,.76.428,2.366,2.366,0,0,0,1.9.594q1.212,0,1.212-.594,0-.428-.737-.606a14.929,14.929,0,0,0-1.77-.3,14.916,14.916,0,0,1-2.079-.392,3.407,3.407,0,0,1-1.782-1.152,3.543,3.543,0,0,1-.737-2.353,3.35,3.35,0,0,1,1.616-2.9,7.416,7.416,0,0,1,4.23-1.093,8.186,8.186,0,0,1,4.17.962,3.84,3.84,0,0,1,1.984,2.578.5.5,0,0,1-.131.475.721.721,0,0,1-.511.167h-3.065a.86.86,0,0,1-.713-.38,1.741,1.741,0,0,0-1.592-.642q-1.283,0-1.283.546,0,.428.784.653a14.923,14.923,0,0,0,1.889.392,17.481,17.481,0,0,1,2.222.487,3.973,3.973,0,0,1,1.9,1.2,3.3,3.3,0,0,1,.784,2.281,3.251,3.251,0,0,1-1.64,2.923,9,9,0,0,1-4.729,1.022",
    transform: "translate(-255.892 -27.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25675",
    "data-name": "Path 25675",
    d: "M437.72,21.062a.629.629,0,0,1-.523.737,9.982,9.982,0,0,1-2.281.262,3.913,3.913,0,0,1-3.541-1.521,4.861,4.861,0,0,1-3.968,1.521A5.953,5.953,0,0,1,422.94,20.3a6.3,6.3,0,0,1-1.711-4.586,6.257,6.257,0,0,1,1.711-4.574A5.974,5.974,0,0,1,427.407,9.4a5.091,5.091,0,0,1,3.208.974v-5.7q0-.641.665-.642h3.707a.567.567,0,0,1,.642.642V16.9a1.281,1.281,0,0,0,.166.76.679.679,0,0,0,.57.214,2.24,2.24,0,0,0,.356-.024q.642,0,.713.546Zm-9.433-2.685a2.116,2.116,0,0,0,1.687-.713,2.875,2.875,0,0,0,.618-1.948,2.886,2.886,0,0,0-.618-1.937,2.1,2.1,0,0,0-1.687-.725,2.033,2.033,0,0,0-1.639.737,2.894,2.894,0,0,0-.618,1.925,2.893,2.893,0,0,0,.618,1.925,2.032,2.032,0,0,0,1.639.737",
    transform: "translate(-344.146 -3.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25676",
    "data-name": "Path 25676",
    d: "M524.043,46.037a7.231,7.231,0,0,1-5.073-1.746,5.93,5.93,0,0,1-1.913-4.6,6.045,6.045,0,0,1,1.818-4.586,7.794,7.794,0,0,1,9.79-.012,6.153,6.153,0,0,1,1.723,4.55v.5q0,.618-.713.618h-7.96a2.193,2.193,0,0,0,2.376,1.758,1.894,1.894,0,0,0,1.283-.452,1.484,1.484,0,0,1,.855-.356h3.327a.623.623,0,0,1,.511.19.513.513,0,0,1,.059.5,4.941,4.941,0,0,1-2.186,2.673,7.4,7.4,0,0,1-3.9.962m-2.3-7.556h4.3a2.007,2.007,0,0,0-.7-1.3A2.167,2.167,0,0,0,523.9,36.7a2.225,2.225,0,0,0-1.438.487,1.966,1.966,0,0,0-.725,1.3",
    transform: "translate(-422.438 -27.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25677",
    "data-name": "Path 25677",
    d: "M636.81,21.6h7.414a.567.567,0,0,1,.642.642v2.97a.567.567,0,0,1-.642.642H632.247q-.666,0-.665-.642V9.861q0-.641.665-.642h3.921a.567.567,0,0,1,.642.642Z",
    transform: "translate(-516.005 -7.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25678",
    "data-name": "Path 25678",
    d: "M716.91,22.06a5.115,5.115,0,0,1-3.16-.867,2.858,2.858,0,0,1-1.141-2.412V4.667q0-.641.665-.642h3.707q.665,0,.665.642V16.9a1.36,1.36,0,0,0,.154.761.645.645,0,0,0,.558.214,2.216,2.216,0,0,0,.356-.024q.642,0,.713.546l.285,2.661a.629.629,0,0,1-.523.737,9.981,9.981,0,0,1-2.281.262",
    transform: "translate(-582.205 -3.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25679",
    "data-name": "Path 25679",
    d: "M773.9,47.055a.608.608,0,0,1-.523.737,9.58,9.58,0,0,1-2.186.261q-2.78,0-3.707-1.521a5.067,5.067,0,0,1-3.921,1.521,4.663,4.663,0,0,1-4.99-4.966v-6.63q0-.618.665-.618h3.707q.665,0,.665.618v5.489q0,1.853,1.544,1.853a1.508,1.508,0,0,0,1.2-.475,1.955,1.955,0,0,0,.416-1.331V36.457q0-.618.642-.618h3.731q.665,0,.665.618v6.368a1.655,1.655,0,0,0,.143.82.6.6,0,0,0,.546.226,2.6,2.6,0,0,0,.4-.024q.642,0,.713.547Z",
    transform: "translate(-619.758 -29.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25680",
    "data-name": "Path 25680",
    d: "M847.707,47.6a.739.739,0,0,1-.76-.5l-4.515-10.526q-.261-.736.546-.737h3.873a.715.715,0,0,1,.76.5l2.115,5.251,2.115-5.251a.822.822,0,0,1,.76-.5h3.873a.6.6,0,0,1,.523.2.531.531,0,0,1,0,.535L852.483,47.1a.723.723,0,0,1-.737.5Z",
    transform: "translate(-688.219 -29.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25681",
    "data-name": "Path 25681",
    d: "M930.7,5.228a2.83,2.83,0,0,1-2.02-.737,2.462,2.462,0,0,1-.784-1.877,2.473,2.473,0,0,1,.784-1.865,3.084,3.084,0,0,1,4.028,0,2.456,2.456,0,0,1,.8,1.865,2.445,2.445,0,0,1-.8,1.877,2.841,2.841,0,0,1-2.008.737M928.847,18.32q-.666,0-.665-.642V7.176q0-.618.665-.618h3.707q.665,0,.665.618v10.5q0,.642-.665.642Z",
    transform: "translate(-758.096 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25682",
    "data-name": "Path 25682",
    d: "M981.916,45.038a.608.608,0,0,1-.523.737,9.8,9.8,0,0,1-2.186.261,4.177,4.177,0,0,1-3.541-1.378,6.218,6.218,0,0,1-4.063,1.378,5.953,5.953,0,0,1-4.467-1.758,6.3,6.3,0,0,1-1.711-4.586,6.257,6.257,0,0,1,1.711-4.574,5.974,5.974,0,0,1,4.467-1.747,4.863,4.863,0,0,1,3.4,1.164v-.1q0-.618.665-.618h3.517q.642,0,.642.618v6.368a1.656,1.656,0,0,0,.143.82.6.6,0,0,0,.546.226,3.154,3.154,0,0,0,.428-.024q.641,0,.713.546Zm-9.433-2.685a2.116,2.116,0,0,0,1.687-.713,3.362,3.362,0,0,0,0-3.885,2.1,2.1,0,0,0-1.687-.725,2.033,2.033,0,0,0-1.639.737,3.307,3.307,0,0,0,0,3.849,2.032,2.032,0,0,0,1.639.737",
    transform: "translate(-788.757 -27.264)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNdllNuevo);
export default __webpack_public_path__ + "static/media/logo_ndll_nuevo.596f88079eecb3e45ab10ea657343016.svg";
export { ForwardRef as ReactComponent };